import { selectIncomeWhenRetired } from 'selectors/dashboard';
import { fetchRetirement } from 'actions/digital-advice';
import { createPage } from './Payouts';

export default createPage({
  getPayoutsAction: fetchRetirement,
  selectPayouts: selectIncomeWhenRetired,
  payoutType: 'retirement',
});
